<template>
  <!-- Sub-view anatomy comes from the shared .drawer-subview partial
       (src/assets/sass/dashboard/custom/_drawer-subview.scss). -->
  <div class="drawer-subview request-decision-view">
    <div class="view-header">
      <button class="back-btn" @click="$emit('back')">
        <i class="tim-icons icon-minimal-left"></i>
      </button>
      <h5 class="view-title mb-0">Deny booking request</h5>
    </div>

    <div class="view-body">
      <div class="subview-warning">
        <i class="tim-icons icon-alert-circle-exc"></i>
        <p v-if="refundAmountLabel">
          Denying this request will release the time slot and automatically refund {{ refundAmountLabel }} to the customer. They will receive a cancellation email.
        </p>
        <p v-else>
          Denying this request will release the time slot. No payment has been captured, so nothing needs to be refunded. The customer will receive a cancellation email.
        </p>
      </div>

      <div class="subview-field">
        <label class="field-label">Reason (optional, shared with the customer)</label>
        <el-input
          v-model="denyReason"
          type="textarea"
          :rows="3"
          :maxlength="500"
          show-word-limit
          placeholder="e.g. We are unable to staff this time. Please pick a slot after 5:30 PM."
        ></el-input>
      </div>

      <div class="subview-actions">
        <base-button type="secondary" size="sm" @click="$emit('back')">Go back</base-button>
        <base-button type="danger" size="sm" :disabled="loading" @click="confirmDeny">
          <span v-if="loading"><i class="el-icon-loading mr-1"></i> Denying...</span>
          <span v-else>Deny request</span>
        </base-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import axios from 'axios';
import { API_LOCATION } from '@/api-config';
import { Auth } from 'aws-amplify';

const props = defineProps<{
  requestId: number;
  companyId: string;
  companyGroupId: number | string;
  refundAmountLabel?: string;
}>();

const emit = defineEmits<{
  (e: 'back'): void;
  (e: 'denied'): void;
  (e: 'error', message: string): void;
}>();

const denyReason = ref('');
const loading = ref(false);

async function confirmDeny() {
  loading.value = true;
  try {
    const session = await Auth.currentSession();
    const config = { headers: { Authorization: session.getIdToken().getJwtToken() } };
    const url = `${API_LOCATION}companies/${props.companyId}/groups/${props.companyGroupId}/booking-requests/${props.requestId}/deny`;
    await axios.post(url, { deny_reason: denyReason.value || null }, config);
    emit('denied');
  } catch (error: any) {
    const message = error?.response?.data?.error || 'The request could not be denied. Please try again.';
    emit('error', message);
  } finally {
    loading.value = false;
  }
}
</script>
